import { Mic, Mail, Github } from "lucide-react";

export default function AboutCard() {
    return (
        <div className="rounded-3xl border border-stone-200/80 dark:border-stone-800 bg-white/70 dark:bg-[#242322]/70 p-6" data-testid="settings-about">
            <div className="text-[11px] tracking-[0.2em] uppercase font-bold text-stone-400">About</div>
            <div className="mt-4 flex items-start gap-3">
                <div className="w-10 h-10 rounded-2xl bg-terracotta flex items-center justify-center text-white shrink-0">
                    <Mic size={18} strokeWidth={1.5} />
                </div>
                <div>
                    <div className="font-serif text-2xl tracking-tight leading-none">Cadence</div>
                    <div className="text-xs text-stone-500 mt-1">Version 1.3 · Built with Whisper + GPT-4o-mini</div>
                </div>
            </div>
            <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
                <a
                    href="mailto:hello@cadence.app"
                    className="flex items-center gap-2 px-4 py-3 rounded-2xl border border-stone-200 dark:border-stone-700 hover:border-stone-400 transition-colors"
                    data-testid="about-contact"
                >
                    <Mail size={14} strokeWidth={1.5} className="text-stone-400" />
                    Get in touch
                </a>
                <a
                    href="https://emergent.sh"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 px-4 py-3 rounded-2xl border border-stone-200 dark:border-stone-700 hover:border-stone-400 transition-colors"
                    data-testid="about-built-with"
                >
                    <Github size={14} strokeWidth={1.5} className="text-stone-400" />
                    Built on Emergent
                </a>
            </div>
            <div className="mt-5 text-[11px] text-stone-400 italic font-serif text-center">
                Made for the moments where the right words matter.
            </div>
        </div>
    );
}
